import { animate, query, style, transition, trigger } from '@angular/animations';

export class OverviewAnimations {
    public static slide = trigger('slide', [
        transition('* <=> *', [
            query(
                ':enter',
                [
                    style({ transform: 'translateX({{offsetEnter}}%)' }),
                    animate('0.2s ease-in-out', style({ transform: 'translateX(0%)' })),
                ],
                { optional: true },
            ),
        ]),
    ]);
}
